import config from '../config';

// Get all payment methods
export const getAllPaymentMethods = async () => {
  const response = await fetch(`${config.apiUrl}/payment-methods`);

  if (!response.ok) throw new Error('Failed to fetch payment methods');
  return response.json();
};

// Get payment methods by client ID
export const getPaymentMethodsByClientId = async (client_id) => {
  const response = await fetch(`${config.apiUrl}/payment-methods/client/${client_id}`);

  if (!response.ok) {
    const errorResponse = await response.json();
    throw new Error(JSON.stringify(errorResponse));
  }
  return response.json();
};

// Get payment method by ID
export const getPaymentMethodById = async (id) => {
  const response = await fetch(`${config.apiUrl}/payment-methods/${id}`);

  if (!response.ok) {
    const errorResponse = await response.json();
    throw new Error(JSON.stringify(errorResponse));
  }
  return response.json();
};

// Create new payment method
export const createPaymentMethod = async (data) => {
  const response = await fetch(`${config.apiUrl}/payment-methods`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });

  if (!response.ok) {
    const errorResponse = await response.json();
    throw new Error(JSON.stringify(errorResponse));
  }
  return response.json();
};

// Update existing payment method
export const updatePaymentMethod = async (data) => {
  const response = await fetch(`${config.apiUrl}/payment-methods/${data.id}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });

  if (!response.ok) {
    const errorResponse = await response.json();
    throw new Error(JSON.stringify(errorResponse));
  }
  return response.json();
};

// Delete (soft delete) payment method
export const deletePaymentMethod = async (id) => {
  const response = await fetch(`${config.apiUrl}/payment-methods/${id}`, {
    method: 'DELETE',
  });

  if (!response.ok) {
    const errorResponse = await response.json();
    throw new Error(JSON.stringify(errorResponse));
  }
  return response.json();
};
